import ModifyPolicyForm from '../screens/ModifyPoliciesForm'
import PoliciesForm from '../screens/PoliciesForm'
import PoliciesTabs from '../screens/PoliciesTabs'
import { ROLE, RouteWithAccessType } from './types'

const cancelPolicyPagesRoleManagement: RouteWithAccessType[] = [
  {
    route: '/policies/(cancel-policies|amendment-policies)',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.PROVIDER_MARKETING,
      ROLE.PROVIDER_IT,
      ROLE.PROVIDER_MANAGEMENT,
      ROLE.CHANNEL_ADMIN,
      ROLE.CHANNEL_ACTIVATION
    ],
    rolesListWithWriteAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.PROVIDER_MARKETING,
      ROLE.PROVIDER_IT,
      ROLE.PROVIDER_MANAGEMENT,
      ROLE.CHANNEL_ACTIVATION
    ],
    requiredFeatures: ['policy.cancel.list', 'policy.amendment.list'],
    component: <PoliciesTabs />,
    // PoliciesTabs gates each tab with canAccessTab, which returns FALSE when a route
    // declares no tabs at all — there is no tabConfig to check. With none declared, the
    // screen redirected every visitor to /403, which had no route, so the page rendered
    // blank for everyone including admins.
    //
    // One feature per tab, split from the two the route already requires. No new
    // permission is introduced: a role reaching this route holds both by definition.
    // The role lists below are INERT today: canAccessTab reads only requiredFeatures.
    // They are populated anyway because their absence is the same shape as the bug this
    // fixes — if a guard ever starts reading tab roles, a tab with none would deny
    // everyone. They mirror the route's own lists exactly, so they widen nothing.
    tabs: [
      {
        params: { page: 'cancel-policies' },
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.PROVIDER_IT,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.CHANNEL_ADMIN,
          ROLE.CHANNEL_ACTIVATION
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.PROVIDER_IT,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.CHANNEL_ACTIVATION
        ],
        requiredFeatures: ['policy.cancel.list']
      },
      {
        params: { page: 'amendment-policies' },
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.PROVIDER_IT,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.CHANNEL_ADMIN,
          ROLE.CHANNEL_ACTIVATION
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.PROVIDER_IT,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.CHANNEL_ACTIVATION
        ],
        requiredFeatures: ['policy.amendment.list']
      }
    ],
    sections: {
      ADD_POLICY_BUTTON: {
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.PROVIDER_IT,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.CHANNEL_ADMIN,
          ROLE.CHANNEL_ACTIVATION
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.PROVIDER_IT,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.CHANNEL_ACTIVATION
        ],
        requiredFeatures: ['policy.cancel.create']
      },
      PROVIDER_SELECTOR: {
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['policy.cancel.list']
      }
    }
  },
  {
    route: '/policies/cancel-policies/create',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.PROVIDER_MARKETING,
      ROLE.PROVIDER_IT,
      ROLE.PROVIDER_MANAGEMENT,
      ROLE.CHANNEL_ADMIN,
      ROLE.CHANNEL_ACTIVATION
    ],
    rolesListWithWriteAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.PROVIDER_MARKETING,
      ROLE.PROVIDER_IT,
      ROLE.PROVIDER_MANAGEMENT,
      ROLE.CHANNEL_ACTIVATION
    ],
    requiredFeatures: ['policy.cancel.create'],
    component: <PoliciesForm />
  },
  {
    route: '/policies/cancel-policies/:providerCode/:id/edit',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.PROVIDER_MARKETING,
      ROLE.PROVIDER_IT,
      ROLE.PROVIDER_MANAGEMENT,
      ROLE.CHANNEL_ADMIN,
      ROLE.CHANNEL_ACTIVATION
    ],
    rolesListWithWriteAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.PROVIDER_MARKETING,
      ROLE.PROVIDER_IT,
      ROLE.PROVIDER_MANAGEMENT,
      ROLE.CHANNEL_ACTIVATION
    ],
    requiredFeatures: ['policy.cancel.edit'],
    component: <PoliciesForm />
  },
  {
    route: '/policies/amendment-policies/create',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.PROVIDER_MARKETING,
      ROLE.PROVIDER_IT,
      ROLE.PROVIDER_MANAGEMENT,
      ROLE.CHANNEL_ADMIN,
      ROLE.CHANNEL_ACTIVATION
    ],
    rolesListWithWriteAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.PROVIDER_MARKETING,
      ROLE.PROVIDER_IT,
      ROLE.PROVIDER_MANAGEMENT,
      ROLE.CHANNEL_ACTIVATION
    ],
    requiredFeatures: ['policy.amendment.create'],
    component: <ModifyPolicyForm />
  },
  {
    route: '/policies/amendment-policies/:providerCode/:id/edit',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.PROVIDER_MARKETING,
      ROLE.PROVIDER_IT,
      ROLE.PROVIDER_MANAGEMENT,
      ROLE.CHANNEL_ADMIN,
      ROLE.CHANNEL_ACTIVATION
    ],
    rolesListWithWriteAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.PROVIDER_MARKETING,
      ROLE.PROVIDER_IT,
      ROLE.PROVIDER_MANAGEMENT,
      ROLE.CHANNEL_ACTIVATION
    ],
    requiredFeatures: ['policy.amendment.edit'],
    component: <ModifyPolicyForm />
  }
]

export default cancelPolicyPagesRoleManagement
